import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function LabsSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Labs"
      description="Opt-in early features. Nothing enrolled here yet."
      eta="Later"
    />
  );
}
